import { getOnboardingVersion } from "@helpers/localStorage"
import PlansPage from "@pages/checkout/PlansPage"
import PlansPageSocialTrust from "@pages/checkout/PlansPageSocialTrust"

export default function PlansPageRouter() {
  if (getOnboardingVersion() === "v2") {
    return <PlansPageSocialTrust />
  }
  return <PlansPage />
}
